module.exports = __webpack_public_path__ + "img/logo.02962fa3.svg";